import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
  Space,
} from "antd";

import React, { useState, useCallback, useEffect } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import SuppliersApi from "../../common/Apis/SuppliersApi";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import DepartmentDropdown from "../../common/DropDowns/Department";
const { Option } = Select;

const AddSuppliers = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const hasHistory = window.history.length > 1;

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    if (hasHistory) {
      navigate(-1);
    } else {
      window.close();
    }

  };
  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      supplierName: data.supplierName,
      description: data.description,
      address: data.address,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data?.institutionId,
      },
    });
    SuppliersApi.CreateSuppliers(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/suppliers");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });

  };


  const [Departments, setDepartments] = React.useState([]);
  const getDepartments = useCallback(() => {
    DepartmentsApi.ListDepartments()
      .then((response) => {
        setDepartments(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getDepartments();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [getDepartments]);



  const [form] = Form.useForm();
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (selectedOptions.includes('all')) {
      const allDepartmentValues = Departments.map((department) => department.id);
      form.setFieldsValue({ institutionId: allDepartmentValues });
    }
  }, [selectedOptions, form, Departments]);

  const handleSelectChange = (value) => {
    setSelectedOptions(value);

    // If 'Select All' is selected, deselect individual department options
    if (value.includes('all')) {
      const allDepartmentValues = Departments.map((department) => department.id);
      const filteredValues = value.filter((val) => val !== 'all');
      console.log(allDepartmentValues)
      console.log(filteredValues)
      form.setFieldsValue({ institutionId: [...filteredValues, ...allDepartmentValues] });
    }
  };

  const options = Departments.map((option) => ({
    value: option.id,
    label: option.institutionName,
  }));

  options.unshift({ value: 'selectAll', label: 'Select All' });


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            form={form}
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="supplierName"
                    label="Supplier Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Supplier Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Supplier Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      placeholder="Description"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <Form.Item
                    name="address"
                    label="Address"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      placeholder="Supplier Address"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <DepartmentDropdown />
                </Col>
              </Row>

              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddSuppliers;
